<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { ProductsModule } from "@modules/products/ProductsModule";
    import { createEventDispatcher } from "svelte";
    import { container } from "tsyringe";

    export let productId: number;
    export let variantId: number | null = null;

    const urlsBuilder = container.resolve(CommonModule).exports.urlsBuilder;
    const productsQuery =
        container.resolve(ProductsModule).exports.productsQuery;
    const productsService =
        container.resolve(ProductsModule).exports.productsService;
    const productStatus$ = productsQuery.selectProductStatus(productId);

    // Fetch product if it's not in the queue
    $: {
        if ($productStatus$ === undefined) {
            productsService.addProductForFetching(productId);
        }
    }

    $: productAndVariantInfo$ = productsQuery.selectProductAndVariant(
        productId,
        variantId
    );
    $: productInfo = {
        product: $productAndVariantInfo$.product,
        variant: $productAndVariantInfo$.variant,
        productUrl: $productAndVariantInfo$.product
            ? urlsBuilder.createProductUrl(
                  $productAndVariantInfo$.product.handle
              )
            : null,
    };

    const dispatch = createEventDispatcher();

    $: {
        if ($productStatus$ === STATUS.READY) {
            dispatch("productReady");
        }
    }
</script>

<slot {productInfo} productStatus={$productStatus$} />
